import { cn } from '@utils';
import * as React from 'react';
import type { TypographyProps } from '../types/typography.types';

const OverlineAccentedTypography = React.forwardRef<HTMLParagraphElement, TypographyProps>(
	({ className, children, truncate = true, ...props }, ref) => (
		<p
			ref={ref}
			className={cn(`scroll-m-20 text-2xs font-semibold ${truncate ? 'truncate' : ''}`, className)}
			data-aid="overline-accented-typography"
			{...props}
		>
			{children}
		</p>
	)
);

OverlineAccentedTypography.displayName = 'OverlineAccentedTypography';

export default OverlineAccentedTypography;
